/**
 * The five sectors HRLabs recruits for, in display order. Slugs and names are code (like
 * `SERVICES`) so URLs and navigation cannot drift from the data; the page content lives in
 * the `sectorPages` collection. A sector page claims method and understanding, never placements
 * that do not exist (the IT page may list roles actually filled, as a labelled block).
 */
export const SECTORS = [
    { key: 'it', slug: { en: 'it-recruitment', bg: 'podbor-na-it-specialisti' }, name: { en: 'IT and technology', bg: 'ИТ и технологии' }, areas: ['backend', 'frontend', 'data', 'qa'], closest: ['finance-accounting', 'manufacturing'] },
    { key: 'finance-accounting', slug: { en: 'finance-accounting-recruitment', bg: 'podbor-na-schetovoditeli-i-finansisti' }, name: { en: 'Finance and accounting', bg: 'Финанси и счетоводство' }, areas: [], closest: ['office-admin', 'sales'] },
    { key: 'sales', slug: { en: 'sales-recruitment', bg: 'podbor-na-targovski-personal' }, name: { en: 'Sales and commercial', bg: 'Продажби и търговия' }, areas: [], closest: ['office-admin', 'finance-accounting'] },
    { key: 'office-admin', slug: { en: 'office-admin-recruitment', bg: 'podbor-na-administrativen-personal' }, name: { en: 'Office and administration', bg: 'Администрация и офис' }, areas: [], closest: ['sales', 'finance-accounting'] },
    { key: 'manufacturing', slug: { en: 'manufacturing-recruitment', bg: 'podbor-na-personal-za-proizvodstvo' }, name: { en: 'Manufacturing and engineering', bg: 'Производство и инженеринг' }, areas: [], closest: ['it', 'office-admin'] },
];
export function sectorBySlug(slug, lang) {
    return SECTORS.find((r) => r.slug[lang] === slug);
}
export function sectorByKey(key) {
    return SECTORS.find((r) => r.key === key);
}
/** The sector matching a job's derived area (undefined when none). */
export function sectorForArea(area) {
    return SECTORS.find((r) => r.areas.includes(area));
}
//# sourceMappingURL=sectorCatalog.js.map